import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import { Button } from 'reactstrap';
import { DELETE_USER } from '../../mutation/mutation';

const DeleteUser = ({ email }) => {
  const [deleteUserMutation] = useMutation(DELETE_USER);

  const deleteUser = () => {
    // eslint-disable-next-line no-alert
    const confirm = window.confirm('Are you sure to delete user ?');
    if (!confirm) {
      return;
    }

    // eslint-disable-next-line no-alert
    const confirm2 = window.confirm('Are you REALLY sure to delete user ? There is no going back after you hit \'Confirm\'.');
    if (!confirm2) {
      return;
    }

    deleteUserMutation({ variables: { email } });
  };

  if (!email) return null;
  return (
    <div>
      <Button
        type="submit"
        color="danger"
        onClick={deleteUser}
      >
        Delete user
      </Button>
      <br />
      ⚠️ It will delete ALL information about the user.
      Use it only if the user asked explicitly to remove his account and all data we have on him.
    </div>
  );
};

export default DeleteUser;



// WEBPACK FOOTER //
// ./src/components/user-info/delete-user.js